import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getConfigurationFacility, updateFacilityIds } from "../../../app/store/config/configActions";
import { clearStepSaleConfig, getStepSaleConfig } from "../../../app/store/stepSaleConfig/saleStepConfigActions";
import EAFullScreenLoader from "../../../app/components/shared/EAFullScreenLoader";
import { CUSTOM_OFFER, EXERCISE_SCHEDULE, LOGIN_PAGE } from "../../../app/routes";
import { useLocation, useNavigate } from "react-router";
import useFacility from "../../../utils/hooks/useFacility";
import { FIT_PARK, FIT_PARK_LOGO, PARK_WODNY, PARK_WODNY_LOGO } from "../hooks/useB2BRegisterLogo";

const KrakowShopChanger: React.FC = () => {
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleUpdateFacilityIds = (ids: string, newPage: string) => {
    setLoading(true);
    dispatch(updateFacilityIds(ids));
    sessionStorage.setItem("facilityId", ids);

    dispatch(clearStepSaleConfig());
    dispatch(getConfigurationFacility(ids));
    dispatch(getStepSaleConfig(ids));

    const targetUrl = new URL(window.location.origin + newPage);
    targetUrl.searchParams.set("id", ids);

    if (location.pathname !== LOGIN_PAGE) {
      // Na pozostałych stronach wykonujemy nawigację do newPage
      navigate(targetUrl.pathname + targetUrl.search, { replace: true });
    } else {
      // Na stronie logowania aktualizujemy tylko parametr "id" w bieżącym URL
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("id", ids);
      window.history.replaceState({}, "", currentUrl.toString());
    }

    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };

  const onChangeKrakowShop = async () => {
    if (facilityIds === FIT_PARK) {
      const newFacilityIds = PARK_WODNY;
      setImageUrl(FIT_PARK_LOGO);
      handleUpdateFacilityIds(newFacilityIds, `${CUSTOM_OFFER}?offerId=sklep`);
    } else if (facilityIds === PARK_WODNY) {
      const newFacilityIds = FIT_PARK;
      setImageUrl(PARK_WODNY_LOGO);
      handleUpdateFacilityIds(newFacilityIds, EXERCISE_SCHEDULE);
    }
  };

  useEffect(() => {
    if (facilityIds === FIT_PARK) {
      setImageUrl(PARK_WODNY_LOGO);
    } else if (facilityIds === PARK_WODNY) {
      setImageUrl(FIT_PARK_LOGO);
    }
  }, [facilityIds]);

  if (loading) {
    return <EAFullScreenLoader loadingMessage="Przełączanie sklepu" />;
  }

  return (
    <div className="krakow-switch">
      {/* <EAIconButton icon={<BsArrowLeftRight />} title="Przełącz sklep" variant="icon" onClick={onChangeKrakowShop} /> */}
      <img src={imageUrl} alt="Logo sklepu" onClick={onChangeKrakowShop} />
    </div>
  );
};

export default KrakowShopChanger;
